<template>
  <li class="nav-item">
    <router-link
      :to="link.path"
      :target="link.target"
      @click="linkClick"
      class="nav-link"
    >
      <font-awesome-icon :icon="icon" v-if="icon" />
      <span class="nav-link-text" :class="{ 'ml-2' : icon}">{{ link.name }}</span>
    </router-link>
  </li>
</template>
<script>
export default {
  name: "sidebar-item",
  props: {
    icon: {
      default: null,
      description: "Icon - import a FontAwesome icon",
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        };
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
    };
  },
  methods: {
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
